import { useForm, Link, usePage } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function SignIn() {
  const { auth } = usePage().props
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      remember_me: false,
    },
  })

  function handleSubmit(e) {
    e.preventDefault()
    post('/sign_in')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">Gosellgo</h1>
          <p className="mt-2 text-gray-600">Logga in på ditt konto</p>
        </div>

        {auth.flash?.alert && (
          <div className="bg-red-50 border border-red-200 text-red-800 rounded-md px-4 py-3 text-sm mb-4">
            {auth.flash.alert}
          </div>
        )}

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="E-post" error={errors['user.email'] || errors.email}>
              <input
                type="email"
                value={data.user.email}
                onChange={e => setData('user.email', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="email"
              />
            </FormField>

            <FormField label="Lösenord" error={errors['user.password'] || errors.password}>
              <input
                type="password"
                value={data.user.password}
                onChange={e => setData('user.password', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="current-password"
              />
            </FormField>

            <Button type="submit" disabled={processing} className="w-full">
              {processing ? 'Loggar in…' : 'Logga in'}
            </Button>
          </form>

          <p className="mt-6 text-center text-sm text-gray-600">
            Har du inget konto?{' '}
            <Link href="/sign_up" className="text-indigo-600 hover:underline">
              Registrera dig
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
